export const benef_const = {
    defalut_retry: 2,
    immunizationVaccinations: ['vit-k', 'hep_b-0', 'bcg', 'opv0'],
    testNotDone: 'Test not done',
    immunizationTable: [
        { age: "Birth", vaccinations: ["OPV 0", "Hep - B 0", "Vit K", "BCG"] },
        { age: "6 Weeks", vaccinations: ["OPV 1", "Pentavelant 1", "RVV 1", "f1PV 1", "PCV 1"] },
        { age: "10 Weeks", vaccinations: ["Pentavelant 2", "OPV 2", "RVV 2"] },
        { age: "14 Weeks", vaccinations: ["OPV 3", "Pentavelant 3", "f1PV 2", "RVV 3", "PCV 2"] },
        { age: "9-12 Months", vaccinations: ["PCV Booster", "(MR)-1", "JE-1**"] },
        { age: "24 Months", vaccinations: ["(MR)-2", "JE-2**", "OPV Booster", "DPT Booster 1"] },
    ],
    tempBenfWarningMessage:"Please note that a beneficiary is already registered with the given Name, Date of Birth, and Gender. Do you still want to proceed?",
    childMinimumAge:5,
    beneficiaryDetails:'Beneficiary Details',
    yesOption: 'Yes',
    notDone:'Not Done',
    ancServiceCode:'anc',
    deliveryOutsideRCH:'Delivery outside JANANI',
    ancServiceReceived:'Received',
    ancServiceReceivedCode:'received',
    ancServiceNotReceivedCode:'not_received',
    ancServiceNotReceived:'Not Received',
    deliveryPreparednessCategoryCode:'delivery_preparedness',
    abortionOutsideRCH:'Abortion outside JANANI',
    beneficiaryMinimumAgeForRegistering:6,
    facilityReferral: {
        referralSent: 'Referrals Sent',
        referralReceived: 'Referrals Received',
        referredFrom: 'Referred From',
        referredTo: 'Referred To'
    },
    aefiReportedCode:'whether_aefi_reported',
    deliveryServices:['delivery_preparedness', 'delivery_details'],
    pncServices:['pnc_mother'],
    abortionCare:['abortion_care'],
    pregnancyClosedViewServiceNames:['Abortion Care '],
    deliveryServiceCode:"Delivery ",
    deliveryCategoryCode:'delivery',
    pregnancyClosure:'Pregnancy Closure',
    canEditANC:[ 'abortion_care', 'delivery_details','delivery','close_pregnancy','auto_close_pregnancy','beneficiary_delivery_details','beneficiary_abortion_details'],
    serviceBarExpandableCodes:['anc', 'pnc_mother', 'abortion_care', 'delivery_details','delivery'],
    serviceBarExpandableCodesForInfo:['anc', 'pnc_mother', 'abortion_care', 'delivery_details'],
    pregnancyClosedServiceNames:['Delivery Details ','Abortion Care '],
    ancServices:['anc_pe_oh', 'anc_rout_anc', 'anc_anc_serv', 'anc_spl_tst', 'anc_td', 'anc_usg'],
    createMessage: "Beneficiary has been verified successfully",
    ancStatusUpdateSuccessMessage: "ANC Service Status has been successfully updated",
    abhaLinkedErrorMessage: "Abha number is already linked with another beneficiary.",
    benfUpdatedSuccessfully: "Beneficiary updated successfully",
    childVerifyMessage: "Parent beneficiary must be verified before proceeding with its verification",
    somethingWentWrong: "Something went wrong",
    childUpdateMessage: 'Child has been successfully updated',
    childCreateFlow: 'create',
    childBeneficiaryRegisterErrorMessage:'To register a child under 5 years of age, please go to Child Tracking Module under Parent/ Guardian account',
    childBeneficiaryMaxAgeErrorMessage: "To register a child above 5 years of age, please go to Beneficiary Registration Module",
    childVerifyFlow: 'verify',
    childCreateMessage: 'Child have been successfully created',
    vaccineDateUpdated: "Vaccination Date has been successfully updated",
    beneficiaryVerifiedMessage: "Beneficiary has been verified successfully",
    genderMisMatchFemale: "The gender mismatch. Please enter the details of a female.",
    genderMisMatchMale: "The gender mismatch. Please enter the details of a male.",
    otpLimitReached: 'Maximum limit to resend OTP is reached. Please try after some time.',
    otpInValid: 'OTP is invalid',
    aadharNotLinkedToMobile: "Aadhar not linked to any mobile no. Please use another method of registration.",
    beneficiaryCreatedMessage: "Beneficiary created successfully",
    reportAefi: 'Report AEFI created successfully',
    child: 'Child',
    lastMenstralDate: 'Last Menstrual Period Date',
    DATE_OF_REGISTRATION: 'Date of Registration',
    success: 'success',
    verifyOptions: {
        phoneNumber: 'Phone_Number',
        aadhar: 'Aadhaar',
        abha: 'ABHA',
        back: 'back',
        submit: "submit",
        otp: "OTP",
        demographics: 'Demographics',
        close: 'close',
        backToOtherMethod: 'backToOtherMethod',
        showExistModal: 'show-exist-modal',
        yes: 'yes',
        face_Authentication: 'Face_Authentication'
    },
    gender: 'Gender'

}

export const benef_error_const = {
    urlNotFound :"The url you are trying to connect doesn't exist.",
    genericAbdmMessage:"Unable to contact ABDM services. Please try again after some time.",
    provideCorrectAadhaar:"Please provide correct Aadhaar number.",
    provideCorrectPhone:"Please provide correct Phone number.",
    provideCorrectPersonalDetails:"Please provide correct personal details.",
    provideCorrectAbha:"Please provide correct ABHA number.",
    retryAfter30sec:"You can request for new OTP after 30 seconds.",
    multipleOTP: "You have requested multiple OTPs Or Exceeded maximum number of attempts for OTP match in this transaction. Please try again in 30 minutes.",
    aadharGatewayUnavailable: "Aadhaar Gateway is unavailable.",
    unableToGenerateOtp:"Unable to generate OTP at the moment. Please try after some time.",
    unableToverifyABHA:"Unable to verify ABHA at the moment. Please try after some time.",
    genderFieldErrorMessage: 'Gender field cannot be empty.'
}

export const benef_life_calendar_const = {
    calendarDataKey: {
        benf_reg_dt: 'benf_reg_dt',
        family_planning_details: 'family_planning_details',
        pregnancy_details: 'pregnancy_details',
        v_death_details: 'v_death_details'
    },
    pregnancyStatus: {
        registration: 'registration',
        family_planning: 'family_planning',
        death: 'death',
        on_going: 'on_going',
        abortion: 'abortion',
        still_birth: 'still_birth',
        success: 'success'
    },
    errorMessageForLifeCalendar :"Error in getting life calender data.",
}

export const benef_api_error_message = {
    GET_API_ERROR_MESSAGE: (apiName: string) => `Error in retrieving data from the ${apiName} API`,
    LATEST_SERVICE_AVAILED_DATE_BY_BENEF_ID: "latest service availed date by beneficiary Id",
}

export const beneficiary_self_registration_error_messages={
    abha_number: "Please enter a valid ABHA number.",
    beneificery_name: "Please enter a valid beneficiary name.",
    Gender: "Please select a valid gender.",
    Beneficiary_DOB: "Please enter a valid date of birth.",
    Beneficiary_Mobile_Number: "Please enter a valid mobile number.",
    Spouse_Name: "Please enter a valid spouse name.",
    abhaAddress: "Please enter a valid ABHA address.",
}